import { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import Toolbar from '@mui/material/Toolbar'
import { func, arrayOf, object } from 'prop-types'
import { CvsAutoComplete } from '@components'
import { t } from '@lingui/core/macro'

const Autocomplete = styled(CvsAutoComplete)`
  max-width: 300px;
`

export const CvsListPickerToolbar = ({ filterChanged = () => {}, options = [] }) => {
  const [selectedOption, setSelectedOption] = useState(options[0]?.value || '')

  useEffect(() => {
    filterChanged(selectedOption)
  }, [selectedOption, filterChanged])

  return (
    <Toolbar>
      <Autocomplete
        margin="dense"
        label={t`Select template`}
        options={options}
        onSelected={item => {
          setSelectedOption(item)
        }}
        selected={selectedOption}
      />
    </Toolbar>
  )
}

CvsListPickerToolbar.propTypes = {
  filterChanged: func,
  options: arrayOf(object),
}
